import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { storageKeys, surveyCompleteResponseMessage, surveyKey } from '../agility-risk.constants';
import { LocalStorageService } from 'angular-2-local-storage';
import { AgilityRiskNavigationService } from './agility-risk-navigation.service';
import { AgilityRiskPermissionService } from './agility-risk-permission.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AgilityRiskService } from './agility-risk.service';
import { AssessmentFlow } from '../agility-risk.enum';
import { AssessmentDistributionInfo } from '../models/assessment-distribution-info';

@Injectable({
  providedIn: 'root'
})
export class AgilityRiskAssessmentRouteGuardService {

  constructor(private router: Router,
              private route: ActivatedRoute,
              private storage: LocalStorageService,
              private navigationService: AgilityRiskNavigationService,
              private permissionService: AgilityRiskPermissionService,
              private ngxPermissionService: NgxPermissionsService,
              private agilityRiskService: AgilityRiskService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise((resolve, reject) => {
      const validateSurveyKey = () => {
        this.agilityRiskService.getAssessmentDistribution().subscribe({
          next: (resp: AssessmentDistributionInfo) => {
            this.storage.set(storageKeys.surveyUserId, resp.contactId.id);
            resolve(true);
          },
          error: (err: any) => {
            if (err?.error?.status === '401' && err?.error?.message === surveyCompleteResponseMessage) {
              resolve(false);
              this.router.navigateByUrl(this.navigationService.moduleBaseAddress + '/assessment/complete');
            } else {
              resolve(false);
              this.router.navigateByUrl(this.navigationService.appHomeAddress);
            }
          }
        });
      };

      if (next.data.flowStep != null && Object.values(AssessmentFlow).indexOf(next.data.flowStep) > -1) {
        switch (next.data.flowStep) {
          case AssessmentFlow.landing:
            if (next.queryParams[surveyKey]) {
              this.storage.set(storageKeys.surveyKey, next.queryParams[surveyKey]);
            }
            validateSurveyKey();
            break;
          case AssessmentFlow.survey:
          case AssessmentFlow.summary:
            if (this.storage.get(storageKeys.surveyKey)) {
              validateSurveyKey();
            } else {
              resolve(false);
              this.router.navigateByUrl(this.navigationService.appHomeAddress);
            }
            break;
          case AssessmentFlow.complete:
            resolve(true);
            break;
        }
      } else {
        resolve(false);
        this.router.navigateByUrl(this.navigationService.appHomeAddress);
      }
    });
  }
}
